import Vue from "vue";
import Vuex from "vuex";
import tableHeight from "./modules/tableHeight";
import user from "./modules/user";
import activeRouter from "./modules/activeRouter";

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    tableHeight,
    user,
    activeRouter
  },
});

export default store;
